<template>
    <div>
        <template>
            <div class="card mb-1">
                <div class="card-header d-block border-bottom">
                    <div class="text-center">
                        <span>
                            <h4 class="font-weight-bolder text-uppercase text-primary">Validasi Pendataan dan Pendalaman
                                Register
                                <br /> Tahun {{ parentFilter.tahun }}
                            </h4>
                            <h5 class="font-weight-normal text-primary"> (Hasil Sensus BMD Inventarisasi KIB B)
                            </h5>
                        </span>
                    </div>
                </div>
                <div class="card-body pt-1">
                    <template v-if="(parentFilter.tahun && parentFilter.kolok)">
                        <b-overlay :show="loadingGetIndex" variant="light" opacity="0.85" blur="2px" rounded="sm">
                            <div class="row">
                                <b-col cols="12">
                                    <div class="d-flex flex-md-row flex-column justify-content-between overflow-auto">
                                        <div class="mr-2 d-flex flex-column flex-wrap"
                                            style="width: max-content; gap: 5px;">
                                            <div>
                                                <span class="font-weight-bolder text-uppercase">Nama PD/UKPD/UPB</span>
                                            </div>
                                            <div>
                                                <span class="font-size-lg">{{ formDatas.nalok || '-' }}</span>
                                            </div>

                                        </div>
                                        <div class="text-center border rounded border-light bg-light-primary"
                                            style="min-width: 200px; width: 200px; height: 70px; position: relative;">
                                            <div
                                                style="position: absolute; top: 20px; left: 50%; transform: translate(-50%, -50%); width: max-content;">
                                                <span class="font-weight-bolder text-uppercase">Status</span>
                                            </div>
                                            <div class="overflow-auto" style="margin: 35px 5px 10px 5px;">
                                                <b-badge variant="light-primary">
                                                    {{ formDatas.status_hasil_akhir_nama }}
                                                </b-badge>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </div>
                            <template v-if="formDatas.detailRegister">
                                <div class="row mt-2">
                                    <div class="col-12 d-flex justify-content-center">
                                        <table class="w-60 border border-1 rounded" style="border-collapse: collapse">
                                            <tr>
                                                <td colspan="3" class="text-center p-1">
                                                    <b>
                                                        Total Register
                                                    </b>:
                                                    <span class="font-weight-bold text-primary">{{
                                                        formDatas.detailRegister.total_bmd }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center m-1 p-1 border border-1">
                                                    <b>
                                                        Total register belum divalidasi P3B
                                                    </b>:
                                                    <span class="font-weight-bold text-primary">{{
                                                        formDatas.detailRegister.menunggu_validasi_p3b }}</span>
                                                </td>
                                                <td class="text-center m-1 p-1 border border-1">
                                                    <b>
                                                        Total register dikembalikan P3B
                                                    </b>:
                                                    <span class="font-weight-bold text-primary">{{
                                                        formDatas.detailRegister.dikembalikan_p3b }}</span>
                                                </td>
                                                <td class="text-center m-1 p-1 border border-1">
                                                    <b>
                                                        Total register divalidasi P3B
                                                    </b>:
                                                    <span class="font-weight-bold text-primary"> {{
                                                        formDatas.detailRegister.selesai_sensus }}</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </template>
                        </b-overlay>
                        <hr />
                    </template>
                    <div class="row">
                        <div class="col-12">
                            <div>
                                <span class="text-muted text-uppercase font-medium-1 font-weight-bold">Filter
                                    Table</span>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-4 col-lg-4">
                                    <b-form-group label="Platform Input" label-for="platformInputFilterTable">
                                        <v-select v-model="formFilterTable.filter_platform" label="text"
                                            :options="optFPlatformInput" />
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-md-4 col-lg-4">
                                    <b-form-group label="Status" label-for="statusFilterTable">
                                        <b-overlay :show="isLoadStatusHasilSensus" variant="light" opacity="0.85"
                                            blur="2px" rounded="sm">
                                            <v-select v-model="formFilterTable.filter_status" label="text"
                                                :options="dsStatusHasilSensus" />
                                        </b-overlay>
                                    </b-form-group>
                                </div>
                                <template v-if="formFilterTable.filter_platform.value == 'mobile'">
                                    <div class="col-12 col-md-4 col-lg-4">
                                        <b-form-group label="Kategori" label-for="permasalahanFilterTable">
                                            <v-select v-model="formFilterTable.filter_kategori" label="text"
                                                :options="optFKategori" />
                                        </b-form-group>
                                    </div>
                                </template>
                                <template v-else-if="formFilterTable.filter_platform.value == 'web'">
                                    <div class="col-12 col-md-4 col-lg-4">
                                        <b-form-group label="Permasalahan BMD" label-for="permasalahanFilterTable">
                                            <v-select v-model="formFilterTable.filter_permasalahan_bmd" label="text"
                                                :options="optFPermasalahanBmd" />
                                        </b-form-group>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <b-row>
                        <b-input-group>
                            <b-input-group-prepend>
                                <v-select id="searchOpt" class="search-filter-option-select"
                                    v-model="formFilterTable.key_cari" label="text" :options="searchOptions" />
                            </b-input-group-prepend>
                            <b-form-input id="Kata" v-model="formFilterTable.cari"
                                placeholder="Pencarian data BMD, pilih kata kunci pencarian lalu terapkan pencarian"
                                type="text" class="d-inline-block" />
                        </b-input-group>
                        <!-- <b-col cols="12">
                            <b-form-group label="Pencarian" label-for="pencarianFilterTable">
                                <b-form-input id="search-data-bmd" v-model="formFilterTable.cari"
                                    placeholder="Pencarian data BMD, ketik kata kunci pencarian lalu tekan enter"
                                    type="text" class="d-inline-block" @keyup.enter="handleSearch" />
                            </b-form-group>
                        </b-col> -->
                    </b-row>
                    <div class="row mt-1">
                        <div class="">
                            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md"
                                @click="handleSearch">
                                <feather-icon icon="SearchIcon" class="mr-1" />Terapkan Pencarian
                            </b-button>
                        </div>
                    </div>
                    <hr />
                    <div class="row d-flex flex-wrap justify-content-between mb-2 g-2" style="margin-bottom: 5px;">
                        <span ref="input" class="text-muted text-uppercase font-medium-1 font-weight-bold">Tabel Daftar
                            Pendataan
                            dan Pendalaman Register </span>
                        <div v-if="cookiesJenisAkun != 'external'">
                            <div>
                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="md"
                                    @click="cetakExcel">
                                    <feather-icon icon="PrinterIcon" class="mr-1" />Download Excel
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <b-row>
                        <b-col cols="12">
                            <vue-good-table theme="polar-bear" :columns="columns" :rows="rows" :pagination-options="{
                                enabled: true, perPage: row, jumpFirstOrLast: true,
                            }" :totalRows="totalRecords" :isLoading.sync="isLoadingTable" mode="remote"
                                @on-sort-change="onSortChange">
                                <template slot="table-row" slot-scope="props">
                                    <div v-if="props.column.field === 'aksi'" style="margin-left: 6px">
                                        <b-button variant="primary" v-b-tooltip.hover title="Detail Hasil Sensus"
                                            class="btn-icon" @click="openDetailDataDialog(props)">
                                            <feather-icon icon="CheckCircleIcon" />
                                        </b-button>
                                    </div>
                                    <div v-else-if="props.column.field === 'tgl_oleh'" class="text-right">
                                        <span>
                                            <span>{{ parserValue('dateOnly', props.row['tgl_oleh']) || '-' }}</span>
                                        </span>
                                    </div>
                                    <div v-else-if="props.column.field === 'total_harga'" class="text-right">
                                        <span>
                                            {{ `${new Intl.NumberFormat('id-ID', {
                                                maximumFractionDigits: 2,
                                            }).format(props.formattedRow[props.column.field])}` }}
                                        </span>
                                    </div>
                                    <div v-else-if="props.column.field === 'pencatatan'">
                                        <div>
                                            <div class="mb-50 text-nowrap d-flex flex-row justify-content-between">
                                                <div class="align-text-top font-weight-bolder text-uppercase">
                                                    <span v-if="props.row['asal_input'] == 'web'">Pendalaman
                                                        Register</span>
                                                    <span v-else>Pendataan</span>
                                                </div>
                                                <div v-b-tooltip.hover.top="'Status Validasi'" class="d-flex flex-row"
                                                    style="gap: 2px">
                                                    <div>
                                                        <b-badge
                                                            :variant="badgeStatus(props.row['status_hasil_sensus'])">
                                                            <span class="text-capitalize">{{
                                                                props.row['status_hasil_sensus_nama']
                                                                }}</span>
                                                        </b-badge>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr class="my-25" />
                                            <div class="text-nowrap mb-25 d-flex justify-content-start">
                                                <span class="align-text-top font-small-5">
                                                    Kode QR Ruang : {{ props.row['qr_ruang'] }}</span>
                                            </div>
                                            <div class="text-nowrap mb-50">
                                                <div v-if="props.row['asal_input'] == 'mobile'"
                                                    class="align-text-top font-small-5">
                                                    <div>
                                                        Kode QR BMD : {{ props.row['kode_qr'] }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-wrap mb-50">
                                                <div class="d-flex justify-content-between" style="gap: 5px">
                                                    <div class="d-flex" style="gap:2px">
                                                        <b-badge variant="light-info">
                                                            <span class="text-capitalize">{{
                                                                props.row['kategori']
                                                                }}</span>
                                                        </b-badge>
                                                        <b-badge variant="light-success">
                                                            <span class="text-capitalize">{{
                                                                props.row['keberadaan'] || props.row['jenis_pendalaman']
                                                                }}</span>
                                                        </b-badge>
                                                        <b-badge v-if="props.row['ganda'] == 'iya'"
                                                            style="background-color:rgba(242, 40, 40, 0.69);color: white;">
                                                            Ganda
                                                        </b-badge>
                                                        <b-badge
                                                            style="background-color: rgb(40 97 242 / 69%);color: white;">
                                                            <feather-icon v-if="props.row['asal_input'] == 'web'"
                                                                icon="MonitorIcon" class="mr-25" />
                                                            <feather-icon v-else icon="SmartphoneIcon" class="mr-25" />
                                                            <span class="text-capitalize">{{
                                                                props.row['asal_input']
                                                                }}</span>
                                                        </b-badge>

                                                    </div>
                                                    <div>
                                                        <small>{{ parserValue('dateTime', props.row['created_at'])
                                                            }}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{ props.formattedRow[props.column.field] }}
                                    </div>
                                </template>
                                <template slot="pagination-bottom">
                                    <div class="d-flex justify-content-between flex-wrap">
                                        <div class="d-flex align-items-center mb-0 mt-1">
                                            <span class="text-nowrap"> Menampilkan 1 hingga </span>
                                            <b-form-select v-model="row" :options="['10', '25', '50']" class="mx-1"
                                                @input="handlePageChange" />
                                            <span class="text-nowrap">
                                                dari {{ totalRecords }} entri
                                            </span>
                                        </div>
                                        <div>
                                            <b-pagination :value="1" :total-rows="totalRecords" :per-page="row"
                                                first-number last-number align="right" prev-class="prev-item"
                                                next-class="next-item" class="mt-1 mb-0" @change="handleChangePage">
                                                <template #prev-text>
                                                    <feather-icon icon="ChevronLeftIcon" size="18" />
                                                </template>
                                                <template #next-text>
                                                    <feather-icon icon="ChevronRightIcon" size="18" />
                                                </template>
                                            </b-pagination>
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                        </b-col>
                    </b-row>
                    <hr />
                    <div class="row mb-2" v-if="!isFinal">
                        <b-overlay class="w-100" :show="loadingGetIndex" variant="light" opacity="0.85" blur="2px"
                            rounded="sm">
                            <div class="card knowledge-base-bg text-center bg-light-primary" style="box-shadow: none;">
                                <div class="card-body ">
                                    <h3 class="text-primary text-uppercase border-bottom pb-1">
                                        Validasi Kepala PD/UKPD/UPB
                                    </h3>
                                    <b-card-text class="mb-2">
                                        <span class="font-weight-normal text-dark">
                                            Kepala PD/UKPD/UPB melakukan validasi terhadap data hasil pendalaman dan
                                            pendataan inventarisasi BMD KIB B yang telah divalidasi P3B seluruh
                                            register.
                                        </span>
                                    </b-card-text>
                                    <div v-if="(parentFilter.tahun && parentFilter.kolok) && ['waiting-validated-ka'].includes(formDatas.status_hasil_akhir) && $can('Validasi-Kepala', 'b-hasil-sensus')"
                                        class="d-flex justify-content-center" style="gap: 5px">
                                        <b-button variant="primary" class="mt-25 mt-md-0"
                                            @click="openKepalaValidasiDialog">
                                            <feather-icon icon="CheckCircleIcon" size="15" class="mr-25" />
                                            <span class="font-weight-bold">Validasi</span>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </b-overlay>
                    </div>
                </div>
            </div>
            <!-- Validasi -->
            <template v-if="(parentFilter.tahun && parentFilter.kolok) && formDatas.urutan >= 1">
                <div v-for="(item, i) in formDatas.workflow" :key="i" class="card mb-1">
                    <div class="card-header border-bottom">
                        <h4 class="font-weight-bold text-uppercase">
                            Validasi Kepala PD/UKPD/UPB
                        </h4>
                    </div>
                    <div class="card-body pt-1">
                        <div class="row mb-2">
                            <div class="col-12 col-md-6 col-lg-6" style="padding: 0 5px 0 5px;">
                                <div class="p-1">
                                    <div>
                                        <span class="font-weight-bolder"> {{ item.status_type == 'register-ajukan-pb' ?
                                            'Diajukan' : 'Divalidasi' }} Oleh</span>
                                    </div>
                                    <div>
                                        <span>{{ item.action_by || '-' }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6" style="padding: 0 5px 0 5px;">
                                <div class="p-1">
                                    <div>
                                        <span class="font-weight-bolder">{{ item.status_type == 'register-ajukan-pb' ?
                                            'Diajukan' : 'Divalidasi' }} Pada</span>
                                    </div>
                                    <div>
                                        <span>{{ parserValue('dateTime', item.action_at) || '-' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <b-modal hide-footer centered id="modal-kepala-validasi" ref="kepalaValidasiModalRef" size="lg" scrollable
                :no-close-on-backdrop="true" title="Validasi Kepala PD/UKPD/UPB">
                <validation-observer ref="modalValidasiKepalaRules">
                    <div class="mb-1 text-center bg-light-warning p-1 rounded">
                        <span class="text-center">
                            Seluruh data hasil pendalaman dan pendataan inventarisasi BMD KIB B akan divalidasi.
                            Silahkan
                            input NRK Kepala PD/UKPD/UPB untuk melanjutkan validasi.
                        </span>
                    </div>
                    <div class="row mb-2">
                        <div class="col-12">
                            <validation-provider #default="{ errors }" name="NRK Pegawai" rules="required">
                                <b-input-group>
                                    <cleave id="cardNumber" v-model="nrkKepala" :options="nrkCleaveOption"
                                        class="form-control" :raw="false" placeholder="Input NRK Kepala" />
                                    <div class="ml-50">
                                        <span class="btn btn-md btn-outline-primary" @click="searchNrk">Cek NRK</span>
                                    </div>
                                </b-input-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </div>
                    </div>
                    <div v-if="formDatasKepalaValidasi.nrk_ka != null">
                        <hr />
                        <b-overlay :show="loadingSearchNrk" variant="light" opacity="0.85" blur="2px" rounded="sm">
                            <div class="row mb-1">
                                <div class="col-12">
                                    <table>
                                        <tr>
                                            <td class="font-weight-bold" style="width: 70px;">NRK</td>
                                            <td class="font-weight-bold" style="width: 10px;">:</td>
                                            <td>{{ formDatasKepalaValidasi.nrk_ka }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold" style="width: 50px;">Nama</td>
                                            <td class="font-weight-bold" style="width: 10px;">:</td>
                                            <td>{{ formDatasKepalaValidasi.nama_ka }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">NIP</td>
                                            <td class="font-weight-bold">:</td>
                                            <td>{{ formDatasKepalaValidasi.nip_ka }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Jabatan</td>
                                            <td class="font-weight-bold">:</td>
                                            <td>{{ formDatasKepalaValidasi.jabatan_ka }}</td>
                                        </tr>
                                    </table>
                                    <div class="my-1 col-12 d-flex flex-row" style="gap: 5px">
                                        <b-form-checkbox v-model="formDatasKepalaValidasi.is_plt_ka" name="some-radios"
                                            :value="'iya'" :unchecked-value="'tidak'">
                                            Menjabat Sebagai PLT Kepala PD/UKPD/UPB
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <span class="font-weight-bold">Dengan ini, menyetujui hasil inventarisasi Barang
                                            Milik
                                            Daerah berupa Peralatan dan
                                            Mesin.</span>
                                    </div>
                                </div>
                            </div>
                        </b-overlay>
                        <hr />
                        <div class="row d-flex justify-content-end">
                            <b-button v-if="!loadingSubmitValidasiKa" variant="primary"
                                @click="confirmKepalaValidasiDialog">
                                <span class="align-middle">Kirim</span>
                            </b-button>
                            <b-button v-else variant="primary" disabled>
                                <b-spinner small />
                                Loading...
                            </b-button>
                        </div>
                    </div>

                </validation-observer>
            </b-modal>
        </template>
        <ModalValidasiP3b :show="showModalDetailData" :data-modal="modalDetailData" @closeDialog="closeDetailDataDialog"
            @confirmDialog="confirmDetailDataDialog" />
    </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { showNotifikasi } from '@/libs/helper';
import hasilSensus from "@/composables/b/hasilSensus";
import masterBRef from "@/composables/master/masterBRef";
import { parserValue } from '@/libs/helper'
import { VueGoodTable } from "vue-good-table";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from "vue-select";
import { VBTooltip, BButton } from 'bootstrap-vue'
import ModalValidasiP3b from '../components/ModalValidasiP3b.vue';
import store from '@/store/index'
import Cleave from 'vue-cleave-component'
import searchOpt from "@/composables/b/searchOpt";
import { closeSistemKibB } from '@/libs/helper';

export default {
    props: {
        fd: { type: Object, required: true },
        parentFilter: { type: Object, required: true }
    },
    setup(props, context) {
        //global variable
        const g = context.root;
        const $route = g.$route;
        const formDatas = ref({});
        const isFinal = ref(false);
        const cookiesJenisAkun = ref(g.$cookies.get("jenisAkun"));

        const loadingGetIndex = ref(false);
        const getData = () => {
            let params = props.parentFilter;
            if ((params.tahun && params.kolok)) {
                loadingGetIndex.value = true;
                hasilSensus.getDetail(g, params).then(res => {
                    formDatas.value = { ...formDatas.value, ...res.data };
                    isFinal.value = Boolean(Number(res.is_final));
                    loadingGetIndex.value = false;
                }).catch(err => {
                    loadingGetIndex.value = false;
                    console.log(err)
                });
            }
        };
        getData();

        const isLoadStatusHasilSensus = ref(false);
        const dsStatusHasilSensus = ref([]);
        const getDsStatusHasilSensus = () => {
            dsStatusHasilSensus.value = [
                {
                    value: 'semua',
                    text: '-- Semua --'
                },
                {
                    value: "dikirim",
                    text: "Menunggu Validasi P3B"
                },
                {
                    value: "dikembalikan",
                    text: "Dikembalikan - P3B"
                },
                {
                    value: "disetujui",
                    text: "Disetujui - P3B"
                }
            ];
            // isLoadStatusHasilSensus.value = true;
            // let params = {
            //     filter_platform: '',
            // }
            // masterBRef.getStatusHasilSensusDs(g, params).then(res => {
            //     if (res.success) {
            //         res.rows.unshift({ text: '-- Semua --', value: 'semua' });
            //         dsStatusHasilSensus.value = res.rows.filter(item => item.value !== "blm-ditautkan");;
            //     }
            //     isLoadStatusHasilSensus.value = false;
            // }).catch(err => {
            //     isLoadStatusHasilSensus.value = false;
            //     dsStatusHasilSensus.value = [];
            //     console.log(err)
            // });
        };

        getDsStatusHasilSensus();
        const isLoadKategoriHasilSensus = ref(false);
        const dsKategoriHasilSensus = ref([]);
        const getDsKategoriHasilSensus = () => {
            // isLoadKategoriHasilSensus.value = true;
            // dsKategoriHasilSensus.value = [];
            // let params = {
            //     filter_platform: '',
            // }
            // masterBRef.getKategoriHasilSensusDs(g, params).then(res => {
            //     if (res.success) {
            //         res.rows.unshift({ text: '-- Semua --', value: 'semua' })
            //         dsKategoriHasilSensus.value = res.rows;
            //     }
            //     isLoadKategoriHasilSensus.value = false;
            // }).catch(err => {
            //     isLoadKategoriHasilSensus.value = false;
            //     dsKategoriHasilSensus.value = [];
            //     console.log(err)
            // });
        };
        // getDsKategoriHasilSensus();
        //variable untuk table
        const start = ref(0);
        const rows = ref([]);
        const row = ref(10);
        const totalRecords = ref(0);
        const sortColumn = ref("");
        const order = ref("");
        const isLoadingTable = ref(false);
        const formFilterTable = ref({
            filter_platform: { text: '-- Pilih Salah Satu --', value: '' },
            filter_status: { text: 'Menunggu Validasi P3B', value: 'dikirim' },
            filter_kategori: { text: '-- Semua --', value: 'semua' },
            filter_permasalahan_bmd: { text: '-- Semua --', value: 'semua' },
            kolok: [props.parentFilter.kolok],
            limit: row.value,
            start: start.value,
            cari: null,
            key_cari: { text: '-- Pilih Key --', value: '' },
        });

        const filterValue = ref({
            filter_platform: '',
            filter_status: 'dikirim',
            filter_kategori: 'semua',
            filter_permasalahan_bmd: 'semua',
            kolok: null,
            limit: row.value,
            start: start.value,
            cari: null,
            key_cari: { text: '-- Pilih Key --', value: '' },

        })
        const getDataBmd = () => {
            isLoadingTable.value = true;
            filterValue.value.kolok = props.parentFilter.kolok;
            filterValue.value.filter_platform = (formFilterTable.value.filter_platform) ? formFilterTable.value.filter_platform.value : '';
            filterValue.value.filter_status = (formFilterTable.value.filter_status) ? formFilterTable.value.filter_status.value : 'semua';
            filterValue.value.key_cari = (formFilterTable.value.key_cari) ? formFilterTable.value.key_cari.value : '';

            if (filterValue.value.filter_platform == 'web') {
                delete filterValue.value.filter_kategori;
            } else if (filterValue.value.filter_platform == 'mobile') {
                delete filterValue.value.filter_permasalahan_bmd;
            }

            //harus ada filter platform
            if (['web', 'mobile'.includes(filterValue.value.filter_platform)]) {
                hasilSensus.getDataBmdHasilSensus(g, filterValue.value).then(resp => {
                    if (resp.success) {
                        rows.value = resp.rows;
                        totalRecords.value = resp.totalRows;
                    } else {
                        rows.value = [];
                        totalRecords.value = 0;
                    }
                    isLoadingTable.value = false;
                }).catch((err) => {
                    console.log(err)
                    isLoadingTable.value = false;
                });
            }

        };
        // getDataBmd();

        const handleSearch = (searching) => {
            filterValue.value.start = 0;
            filterValue.value.filter_platform = (formFilterTable.value.filter_platform) ? formFilterTable.value.filter_platform.value : 'semua';
            filterValue.value.filter_status = (formFilterTable.value.filter_status) ? formFilterTable.value.filter_status.value : 'semua';
            filterValue.value.filter_kategori = (formFilterTable.value.filter_kategori) ? formFilterTable.value.filter_kategori.value : null;
            filterValue.value.filter_permasalahan_bmd = (formFilterTable.value.filter_permasalahan_bmd) ? formFilterTable.value.filter_permasalahan_bmd.value : null;
            if (filterValue.value.filter_platform == '') {
                filterValue.value.filter_kategori = 'semua';
                filterValue.value.filter_permasalahan_bmd = 'semua';
            }

            filterValue.value.cari = formFilterTable.value.cari;
            getDataBmd();
        };

        const handlePageChange = (length) => {
            filterValue.value.limit = length;
            getDataBmd();
        };

        const handleChangePage = (page) => {
            filterValue.value.start = (page - 1) * row.value;
            getDataBmd();
        };

        const onSortChange = (params) => {
            sortColumn.value = params[0].field;
            order.value = params[0].type;
            getDataBmd();
        };

        /* Validasi */
        const nrkKepala = ref('');
        const formDatasKepalaValidasi = ref({
            username: g.$cookies.get("username"),
            is_validasi: 'setuju',
            catatan: null,
            nrk_ka: null,
            nama_ka: null,
            nip_ka: null,
            jabatan_ka: null,
            is_plt_ka: 'tidak'
        });
        const kepalaValidasiModalRef = ref(null);
        const openKepalaValidasiDialog = () => {
            kepalaValidasiModalRef.value.show();
        };
        const loadingSubmitValidasiKa = ref(false);
        const confirmKepalaValidasiDialog = () => {
            let fd = { ...formDatasKepalaValidasi.value };
            fd.kolok = formDatas.value.kolok;
            hasilSensus.validasiKepala(g, fd).then(resp => {
                if (resp.success) {
                    getData();
                    showNotifikasi(g, 'success', 'Success', resp.message)
                    context.emit('changeStateEvent', 'list');
                    context.refs.kepalaValidasiModalRef.toggle('#toggle-btn');
                } else {
                    showNotifikasi(g, 'danger', 'Error', resp.message)
                }
            }).catch(err => {
                console.log(err)
            });
        };

        const loadingSearchNrk = ref(false);
        const searchNrk = (e) => {
            if (nrkKepala.value) {
                loadingSearchNrk.value = true;
                hasilSensus.getNrkSingleData(g, { nrk: nrkKepala.value }).then(resp => {
                    if (resp.data) {
                        formDatasKepalaValidasi.value.nrk_ka = resp.data.nrk;
                        formDatasKepalaValidasi.value.nama_ka = resp.data.nama;
                        formDatasKepalaValidasi.value.nip_ka = resp.data.nip;
                        formDatasKepalaValidasi.value.jabatan_ka = resp.data.jabatan;
                        loadingSearchNrk.value = false;
                    } else {
                        loadingSearchNrk.value = false;
                        showNotifikasi(g, 'warning', 'Warning', resp.message)
                    }
                }).catch((err) => {
                    loadingSearchNrk.value = false;
                    console.log(err);
                });
            }
        }

        /* Modal Validasi P3B */
        const modalDetailData = ref({});
        const showModalDetailData = ref(false);
        const openDetailDataDialog = (item) => {
            showModalDetailData.value = true;
            modalDetailData.value = item.row;
        };
        const closeDetailDataDialog = (item) => {
            showModalDetailData.value = false;
        };

        const confirmDetailDataDialog = () => {
            getData();
            getDataBmd();
            showModalDetailData.value = false;
        };

        /* Download Excel */
        const loadingCetak = ref(false)
        const cetakExcel = () => {
            const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna-b/report/tarikan?kolok=' + props.parentFilter.kolok; // Replace with your specific link
            window.open(linkToOpen, '_blank');
        };

        /* Search Option */
        const searchOptions = ref([]);
        const getSearchOptions = () => {
            searchOptions.value = [
                {
                    "value": "guid_aset",
                    "text": "Guid Aset"
                },
                {
                    "value": "kobar",
                    "text": "Kode Barang"
                },
                {
                    "value": "nabar",
                    "text": "Nama Barang"
                },
                {
                    "value": "kode_qr",
                    "text": "Qr Barang"
                },
                {
                    "value": "tgl_oleh",
                    "text": "Tahun Oleh"
                },
                {
                    "value": "nopol",
                    "text": "Nopol"
                },
                {
                    "value": "merk",
                    "text": "Merk"
                },
                {
                    "value": "tipe",
                    "text": "Tipe"
                }
            ];
            // searchOpt.getSearchOpt(g, { list: 'validasi_sensus' }).then(resp => {
            //     if (resp.success) {
            //         searchOptions.value = resp.rows
            //     } else {
            //     }
            //     searchOptions.value.unshift({ text: '-- Pilih Key --', value: '' })

            // }).catch(err => {
            //     console.log(err)
            // })
        };
        getSearchOptions();

        const closeSistemInformation = ref({});
        setInterval(() => {
            closeSistemInformation.value = closeSistemKibB();
        }, 1000);

        return {
            cookiesJenisAkun,
            parserValue,
            loadingGetIndex,
            getData,
            getDataBmd,
            formDatas,

            isLoadStatusHasilSensus,
            dsStatusHasilSensus,
            isLoadKategoriHasilSensus,
            dsKategoriHasilSensus,

            /* Table */
            formFilterTable,
            filterValue,
            handleSearch,
            handlePageChange,
            handleChangePage,
            onSortChange,
            rows,
            start,
            row,
            totalRecords,
            sortColumn,
            order,
            isLoadingTable,

            openKepalaValidasiDialog,
            kepalaValidasiModalRef,
            formDatasKepalaValidasi,
            confirmKepalaValidasiDialog,
            nrkKepala,
            searchNrk,
            loadingSearchNrk,
            loadingSubmitValidasiKa,

            /* Modal Detail Data */
            showModalDetailData,
            modalDetailData,
            openDetailDataDialog,
            closeDetailDataDialog,
            confirmDetailDataDialog,

            loadingCetak,
            cetakExcel,
            searchOptions,
            closeSistemInformation,
            isFinal
        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        VueGoodTable,
        vSelect,
        ModalValidasiP3b,
        Cleave
    },
    watch: {
        parentFilter: {
            handler(newVal, oldVal) {
                this.getData();
                this.getDataBmd();
            },
            deep: true
        }
    },
    methods: {
        changeStateEvent(event) {
            this.$emit('changeStateEvent', event);
        },
        badgeStatus(status) {
            if (status == 'dikirim') {
                return 'light-secondary';
            } else if (status == 'disetujui') {
                return 'light-success';
            } else if (status == 'dikembalikan') {
                return 'light-danger';
            }
        },
    },
    data() {
        return {
            imgUrl: require('@/assets/images/pages/coming-soon.svg'),
            required,
            optFPlatformInput: [
                { text: '-- Pilih Salah Satu --', value: '' },
                { text: 'Mobile', value: 'mobile' },
                { text: 'Web', value: 'web' }
            ],
            optFKategori: [
                { text: '-- Semua --', value: 'semua' },
                { text: 'Tercatat', value: 'tercatat' },
                { text: 'Belum Tercatat', value: 'belum-tercatat' },
                { text: 'Ganda', value: 'ganda' }
            ],
            optFPermasalahanBmd: [
                { text: '-- Semua --', value: 'semua' },
                { text: 'Biaya Biaya', value: 'biaya-biaya' },
                { text: 'Fisik Tidak Ditemukan', value: 'fisik-tidak-ditemukan' }
            ],
            nrkCleaveOption: {
                blocks: [100], // Specify the blocks with the desired length
                numericOnly: true,
            },
            columns: [
                {
                    label: "Aksi",
                    field: "aksi",
                    width: '70px',
                    thClass: 'text-uppercase bg-light-primary pb-1 px-0 text-center',
                    sortable: false,
                },
                {
                    label: "Hasil Sensus",
                    field: "pencatatan",
                    width: '550px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Guid Aset",
                    field: "guid_aset",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Kolok",
                    field: "kolok",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nalok",
                    field: "nalok",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Register",
                    field: "noreg_108",
                    width: '175px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Kode Barang",
                    field: "kobar_108",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nama Barang",
                    field: "nabar_108",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Tanggal Perolehan",
                    field: "tgl_oleh",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Total Harga",
                    field: "total_harga",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Bahan",
                    field: "bahan",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Merk",
                    field: "merk",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Tipe",
                    field: "tipe",
                    width: '350px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Chasis",
                    field: "nochasis",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Mesin",
                    field: "nomesin",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Polisi",
                    field: "nopol",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor BPKB",
                    field: "nobpkb",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
            ],
        };
    },
    directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>